export const containerEmployee = {
  width: '100%',
  background: '#f6f7fc',
  height: 'auto',
  minHeight: '100vh',
};

export const searchContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '95%',
  margin: 'auto',
  marginBottom: '3rem',
  justifyContent: 'space-between',
};

export const findContainer = {
  display: 'flex',
  width: '60%',
  justifyContent: 'flex-end',
};

export default {
  containerEmployee,
  searchContainer,
  findContainer,
};
